export default "__VITE_ASSET__xK0aRHLP__"